import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { dashboardQKeys } from "@hooks/queries/dashboard/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export interface IssuePayoutPayload {
  recipient_id: string;
  amount: number;
  payout_method: string;
  status: "completed";
  description?: string;
  bank_account_number?: string;
  bank_name?: string;
  mobile_money_number?: string;
  period_start?: string;
  period_end?: string;
  processed_at?: string;
  dateRange: string;
  startDate?: string;
  endDate?: string;
}

export const useIssuePayout = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IssuePayoutPayload) => {
      const { dateRange, startDate, endDate, ...body } = payload;
      return api.post("payouts/issue", {
        ...body,
        payout_type: "commission",
      }, {
        params: {
          range: dateRange.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Payout issued successfully.",
        color: "green",
      });
      // Invalidate both the table data and the summary cards
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.earningsByServices(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payoutSummary(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payouts(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.all(),
      });
    },
    onError: (res: any) => {
      console.error("[From Issue Payout Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};

